import styled from "styled-components";

export const Header = styled.h1`
  text-align: center;
  margin-top: 120px;
  color: #000;  /* Changed to black */
  margin-bottom: 20px;
  font-size: 30px;
`;

export const Container = styled.div`
  width: 93%;
  padding-right: 1.5rem;  /* Fixed padding values */
  padding-left: 0.75rem;
  margin-right: auto;
  margin-left: auto;
`;

export const card = {
  marginTop: "10px",
  marginBottom: "50px",
};
